import Vue from 'vue' 
import SvgIcon from '@/components/SvgIcon.vue' // svg组件
import  ToolboxMenu from "@/components/toolboxmenu/ToolboxMenu.vue";
import ToolboxMenuItem from "@/components/toolboxmenu/ToolboxMenuItem.vue";
Vue.component('xy-toolbox-menu', ToolboxMenu);
Vue.component("xy-toolbox-menu-item", ToolboxMenuItem)
Vue.component('svg-icon', SvgIcon);


 
// import plTable from 'pl-table'
// import 'pl-table/themes/index.css' // 引入样式（必须引入)，请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
// import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
// Vue.use(plTable);


// import ElBigdataTable from 'vue-elementui-bigdata-table';
// Vue.use(ElBigdataTable)

import VueAutoVirtualScrollList from 'vue-auto-virtual-scroll-list';
Vue.component('VueAutoVirtualScrollList', VueAutoVirtualScrollList);